// Partner console › Stock and lifecycle (static demo pages/Admin.jsx Partner
// "stock") on real data: the sensors' lifecycle as a pipeline (in HQ stock,
// bench-tested, installed, installed but silent), the stock with "Install",
// and the deliveries (sensors onboarded per day).
import { useState } from "preact/hooks";
import { Link } from "wouter-preact";
import { useT } from "../i18n";
import { go } from "../lib/nav";
import { accountName, accounts } from "../lib/account";
import { useFleet } from "../data/fleet";
import type { Point } from "../data/locations";
import { InstallDialog } from "../components/InstallDialog";
import { State } from "./common";

export const inStock = (p: Point) => !p.labels.site && (!p.owner || !accounts.value.find((a) => a.id === p.owner)?.parent_id);

export default function Stock() {
  const t = useT();
  const f = useFleet(t.lang);
  const [dlg, setDlg] = useState<Point | null>(null);
  if (!f) return <div class="page"><State loading /></div>;
  const day = 864e5, now = Date.now();
  const stock = f.points.filter(inStock);
  const tested = stock.filter((p) => p.lastContact && now - Date.parse(p.lastContact) < day);
  const installed = f.points.filter((p) => !inStock(p));
  const silent = installed.filter((p) => p.st === "delayed");
  const stages: [string, number][] = [["x.lc.stock", stock.length], ["x.lc.tested", tested.length], ["x.lc.installed", installed.length], ["x.lc.silent", silent.length]];
  return (
    <div class="page">
      <div class="page-h"><div><h1>{t("nav.partnerConsole")}</h1><div class="sub">{t("pc.sub")}</div></div></div>
      <div class="tabs">{["customers", "stock", "usage"].map((k) => <button key={k} class={k === "stock" ? "on" : ""} onClick={() => go("/partner" + (k === "customers" ? "" : "/" + k))}>{t("pc.tab." + k)}</button>)}</div>
      <section class="card"><div class="card-h"><h2>{t("pc.lifecycle")}</h2></div>
        <div class="pipeline">{stages.map(([k, n], i) => <div key={k} class="stage"><span class="mono sub2">{i + 1}</span><b class="mono">{t.num(n)}</b><span>{t(k)}</span></div>)}</div>
        <p class="sub2" style="margin:12px 0 0">{t("x.lc.note")}</p></section>
      <section class="card"><div class="card-h"><h2>{t("x.lc.stockList")}</h2><Link class="btn" href="/devices">{t("x.addSensor")}</Link></div>
        {stock.length === 0 ? <p style="margin:0;color:var(--muted)">{t("x.lc.empty")}</p> : (
          <table class="t" style="font-size:14px"><thead><tr><th>{t("devs.device")}</th><th>{t("x.lastContact")}</th><th class="n">{t("cab.battery")}</th><th>{t("x.lc.bench")}</th><th /></tr></thead>
            <tbody>{stock.map((p) => { const ok = p.lastContact && now - Date.parse(p.lastContact) < day; return (
              <tr key={p.id}><td><Link href={"/devices/" + p.id}><b class="mono">{p.serial}</b></Link></td><td>{t.ago(p.lastContact)}</td><td class="n">{p.battery == null ? "—" : t.num(p.battery) + "%"}</td>
                <td><span class={"st st-" + (ok ? "ok" : "delayed")}>{ok ? t("x.lc.benchOk") : t("x.lc.benchWait")}</span></td>
                <td><button class="btn" type="button" onClick={() => setDlg(p)}>{t("x.inst.btn")}</button></td></tr>); })}</tbody></table>)}
      </section>
      <section class="card"><div class="card-h"><h2>{t("x.lc.recent")}</h2></div>
        {f.installs.length === 0 ? <p style="margin:0;color:var(--muted)">—</p> : (
          <table class="t" style="font-size:14px"><thead><tr><th>{t("dev.time")}</th><th>{t("devs.device")}</th><th>{t("x.lc.where")}</th><th>{t("app.customer")}</th><th>{t("x.lc.by")}</th></tr></thead>
            <tbody>{f.installs.slice(0, 20).map((x) => <tr key={x.id}><td class="mono">{new Date(x.occurred_at).toLocaleString(t.locale, { dateStyle: "short", timeStyle: "short" })}</td><td class="mono">{x.device_serial}</td><td>{x.body.stock ? t("x.lc.backHq") : `${x.body.cabinet} · ${x.body.site}`}</td><td>{x.body.stock ? "—" : accountName(x.body.account_id)}</td><td>{x.author_name}</td></tr>)}</tbody></table>)}
      </section>
      {dlg && <InstallDialog p={dlg} mode="install" onClose={() => setDlg(null)} />}
    </div>
  );
}
